import { InjectionKey } from "vue";
import { LayoutService } from "../services/layout/layout-service";

export const APP_LAYOUT_SERVICE_INJECTION_TOKEN: InjectionKey<LayoutService> =
  Symbol("APP_LAYOUT_SERVICE_INJECTION_TOKEN");
